import { useEffect, useState } from 'react'
import { useBogo } from '@mc/bogo-utils'
import { DISCOUNT_VIEWED } from '@mc/constants'
import { useStaticData } from '@mc/static-data-react'
import { isBogoPromoModalDismissed } from '../components/BogoPromoModal/isBogoPromoModalDismissed'

export const useShouldShowBogoPromoModal = () => {
  const [shouldShowBogoPromoModal, setShouldShowBogoPromoModal] = useState<
    boolean | undefined
  >(undefined)
  const { query, promoCode } = useStaticData<{
    query: { promo_id?: string }
    promoCode?: string
  }>()
  const promoId = query?.promo_id
  const discountSlug = promoCode || promoId
  const { isBogoOfferEligible } = useBogo()

  useEffect(() => {
    const discountModalViewed = window.sessionStorage.getItem(DISCOUNT_VIEWED)

    const showBogoPromoModal =
      !isBogoPromoModalDismissed() &&
      (!!discountModalViewed || !discountSlug) &&
      isBogoOfferEligible

    setShouldShowBogoPromoModal(showBogoPromoModal)
  }, [discountSlug, isBogoOfferEligible])

  return { shouldShowBogoPromoModal }
}
